import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { linkStyle } from './Link.css';

type Props = ComponentPropsWithRef<'a'>;

export const ExternalLink = ({ children, ...delegated }: Props) => {
  return (
    <a
      {...delegated}
      className={clsx(linkStyle, delegated.className)}
      rel={delegated.rel ?? 'noreferrer'}
      target={delegated.target ?? '_blank'}
    >
      {children}
    </a>
  );
};
